// @ts-nocheck
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";

replaceInChain(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        accountId: API_URL_CURRENT_FRAGMENT,
        expand: ["approvers", "roles"], // Foundation
    };
});
